const isVite = () => {
  return import.meta.env?.MODE as string | undefined;
};

export const isDevEnv = (fallback: boolean): boolean => {
  const viteMode = isVite();
    console.log(`[viteMode]: ${viteMode}`);
    if (viteMode === 'development') {
      return true;
    }
    if (viteMode === 'production') {
      return false;
    }
    return fallback;
};
